var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Basic Alerts")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('a', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-1",
            modifiers: {
              "collapse-1": true
            }
          }],
          staticClass: "text-primary float-right",
          attrs: {
            "role": "button"
          }
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', {
          staticClass: "mb-4"
        }, [_vm._v("Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever")]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-1"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "basic-alert"
          }
        }, [_c('code', [_vm._v("\n<b-alert :show=\"true\" variant=\"primary\">\n  <div class=\"iq-alert-text\">A simple <b>primary</b> alert—check it out!</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\"secondary\">\n  <div class=\"iq-alert-text\">A simple <b>secondary</b> alert—check it out!</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\"success\">\n  <div class=\"iq-alert-text\">A simple <b>success</b> alert—check it out!</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\"danger\">\n  <div class=\"iq-alert-text\">A simple <b>danger</b> alert—check it out!</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\"warning\">\n  <div class=\"iq-alert-text\">A simple <b>warning</b> alert—check it out!</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\"info\">\n  <div class=\"iq-alert-text\">A simple <b>info</b> alert—check it out!</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\"light\">\n  <div class=\"iq-alert-text\">A simple <b>light</b> alert—check it out!</div>\n</b-alert>\n")])])])])]), _c('b-alert', {
          attrs: {
            "show": true,
            "variant": "primary"
          }
        }, [_c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("primary")]), _vm._v(" alert—check it out!")])]), _c('b-alert', {
          attrs: {
            "show": true,
            "variant": "secondary"
          }
        }, [_c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("secondary")]), _vm._v(" alert—check it out!")])]), _c('b-alert', {
          attrs: {
            "show": true,
            "variant": "success"
          }
        }, [_c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("success")]), _vm._v(" alert—check it out!")])]), _c('b-alert', {
          attrs: {
            "show": true,
            "variant": "danger"
          }
        }, [_c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("danger")]), _vm._v(" alert—check it out!")])]), _c('b-alert', {
          attrs: {
            "show": true,
            "variant": "warning"
          }
        }, [_c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("warning")]), _vm._v(" alert—check it out!")])]), _c('b-alert', {
          attrs: {
            "show": true,
            "variant": "info"
          }
        }, [_c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("info")]), _vm._v(" alert—check it out!")])]), _c('b-alert', {
          attrs: {
            "show": true,
            "variant": "light"
          }
        }, [_c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("light")]), _vm._v(" alert—check it out!")])])];
      },
      proxy: true
    }])
  })], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Basic Alerts With Icons")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('a', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-2",
            modifiers: {
              "collapse-2": true
            }
          }],
          staticClass: "text-primary float-right",
          attrs: {
            "role": "button"
          }
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', {
          staticClass: "mb-4"
        }, [_vm._v("Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever")]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-2"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "basic-alert-icon"
          }
        }, [_c('code', [_vm._v("\n<b-alert :show=\"true\" variant=\"primary\">\n  <div class=\"iq-alert-icon\">\n    <i class=\"ri-alert-line\"></i>\n  </div>\n  <div class=\"iq-alert-text\">A simple <b>primary</b> alert—check it out!</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\"secondary\">\n  <div class=\"iq-alert-icon\">\n    <i class=\"ri-information-line\"></i>\n  </div>\n  <div class=\"iq-alert-text\">A simple <b>secondary</b> alert—check it out!</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\"success\">\n  <div class=\"iq-alert-icon\">\n    <i class=\"ri-alert-line\"></i>\n  </div>\n  <div class=\"iq-alert-text\">A simple <b>success</b> alert—check it out!</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\"danger\">\n  <div class=\"iq-alert-icon\">\n    <i class=\"ri-information-line\"></i>\n  </div>\n  <div class=\"iq-alert-text\">A simple <b>danger</b> alert—check it out!</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\"warning\">\n  <div class=\"iq-alert-icon\">\n    <i class=\"ri-alert-line\"></i>\n  </div>\n  <div class=\"iq-alert-text\">A simple <b>warning</b> alert—check it out!</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\"info\">\n  <div class=\"iq-alert-icon\">\n    <i class=\"ri-information-line\"></i>\n  </div>\n  <div class=\"iq-alert-text\">A simple <b>info</b> alert—check it out!</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\"light\">\n  <div class=\"iq-alert-icon\">\n    <i class=\"ri-alert-line\"></i>\n  </div>\n  <div class=\"iq-alert-text\">A simple <b>light</b> alert—check it out!</div>\n</b-alert>\n")])])])])]), _c('b-alert', {
          attrs: {
            "show": true,
            "variant": "primary"
          }
        }, [_c('div', {
          staticClass: "iq-alert-icon"
        }, [_c('i', {
          staticClass: "ri-alert-line"
        })]), _c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("primary")]), _vm._v(" alert—check it out!")])]), _c('b-alert', {
          attrs: {
            "show": true,
            "variant": "secondary"
          }
        }, [_c('div', {
          staticClass: "iq-alert-icon"
        }, [_c('i', {
          staticClass: "ri-information-line"
        })]), _c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("secondary")]), _vm._v(" alert—check it out!")])]), _c('b-alert', {
          attrs: {
            "show": true,
            "variant": "success"
          }
        }, [_c('div', {
          staticClass: "iq-alert-icon"
        }, [_c('i', {
          staticClass: "ri-alert-line"
        })]), _c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("success")]), _vm._v(" alert—check it out!")])]), _c('b-alert', {
          attrs: {
            "show": true,
            "variant": "danger"
          }
        }, [_c('div', {
          staticClass: "iq-alert-icon"
        }, [_c('i', {
          staticClass: "ri-information-line"
        })]), _c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("danger")]), _vm._v(" alert—check it out!")])]), _c('b-alert', {
          attrs: {
            "show": true,
            "variant": "warning"
          }
        }, [_c('div', {
          staticClass: "iq-alert-icon"
        }, [_c('i', {
          staticClass: "ri-alert-line"
        })]), _c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("warning")]), _vm._v(" alert—check it out!")])]), _c('b-alert', {
          attrs: {
            "show": true,
            "variant": "info"
          }
        }, [_c('div', {
          staticClass: "iq-alert-icon"
        }, [_c('i', {
          staticClass: "ri-information-line"
        })]), _c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("info")]), _vm._v(" alert—check it out!")])]), _c('b-alert', {
          attrs: {
            "show": true,
            "variant": "light"
          }
        }, [_c('div', {
          staticClass: "iq-alert-icon"
        }, [_c('i', {
          staticClass: "ri-alert-line"
        })]), _c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("light")]), _vm._v(" alert—check it out!")])])];
      },
      proxy: true
    }])
  })], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Basic Line Alerts")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('a', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-3",
            modifiers: {
              "collapse-3": true
            }
          }],
          staticClass: "text-primary float-right",
          attrs: {
            "role": "button"
          }
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', {
          staticClass: "mb-4"
        }, [_vm._v("Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever")]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-3"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "basic-line-alert"
          }
        }, [_c('code', [_vm._v("\n<b-alert :show=\"true\" variant=\"primary\" class=\"bg-white\">\n  <div class=\"iq-alert-text\">A simple <b>primary</b> alert—check it out!</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\"secondary\" class=\"bg-white\">\n  <div class=\"iq-alert-text\">A simple <b>secondary</b> alert—check it out!</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\"success\" class=\"bg-white\">\n  <div class=\"iq-alert-text\">A simple <b>success</b> alert—check it out!</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\"danger\" class=\"bg-white\">\n  <div class=\"iq-alert-text\">A simple <b>danger</b> alert—check it out!</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\"warning\" class=\"bg-white\">\n  <div class=\"iq-alert-text\">A simple <b>warning</b> alert—check it out!</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\"info\" class=\"bg-white\">\n  <div class=\"iq-alert-text\">A simple <b>info</b> alert—check it out!</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\"light\" class=\"bg-white\">\n  <div class=\"iq-alert-text\">A simple <b>light</b> alert—check it out!</div>\n</b-alert>\n")])])])])]), _c('b-alert', {
          staticClass: "bg-white",
          attrs: {
            "show": true,
            "variant": "primary"
          }
        }, [_c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("primary")]), _vm._v(" alert—check it out!")])]), _c('b-alert', {
          staticClass: "bg-white",
          attrs: {
            "show": true,
            "variant": "secondary"
          }
        }, [_c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("secondary")]), _vm._v(" alert—check it out!")])]), _c('b-alert', {
          staticClass: "bg-white",
          attrs: {
            "show": true,
            "variant": "success"
          }
        }, [_c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("success")]), _vm._v(" alert—check it out!")])]), _c('b-alert', {
          staticClass: "bg-white",
          attrs: {
            "show": true,
            "variant": "danger"
          }
        }, [_c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("danger")]), _vm._v(" alert—check it out!")])]), _c('b-alert', {
          staticClass: "bg-white",
          attrs: {
            "show": true,
            "variant": "warning"
          }
        }, [_c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("warning")]), _vm._v(" alert—check it out!")])]), _c('b-alert', {
          staticClass: "bg-white",
          attrs: {
            "show": true,
            "variant": "info"
          }
        }, [_c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("info")]), _vm._v(" alert—check it out!")])]), _c('b-alert', {
          staticClass: "bg-white",
          attrs: {
            "show": true,
            "variant": "light"
          }
        }, [_c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("light")]), _vm._v(" alert—check it out!")])])];
      },
      proxy: true
    }])
  })], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Basic Line Alerts With Icons")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('a', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-4",
            modifiers: {
              "collapse-4": true
            }
          }],
          staticClass: "text-primary float-right",
          attrs: {
            "role": "button"
          }
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', {
          staticClass: "mb-4"
        }, [_vm._v("Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever")]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-4"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "basic-line-alert-icon"
          }
        }, [_c('code', [_vm._v("\n<b-alert :show=\"true\" variant=\"primary\" class=\"bg-white\">\n  <div class=\"iq-alert-icon\">\n    <i class=\"ri-alert-line\"></i>\n  </div>\n  <div class=\"iq-alert-text\">A simple <b>primary</b> alert—check it out!</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\"secondary\" class=\"bg-white\">\n  <div class=\"iq-alert-icon\">\n    <i class=\"ri-information-line\"></i>\n  </div>\n  <div class=\"iq-alert-text\">A simple <b>secondary</b> alert—check it out!</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\"success\" class=\"bg-white\">\n  <div class=\"iq-alert-icon\">\n    <i class=\"ri-alert-line\"></i>\n  </div>\n  <div class=\"iq-alert-text\">A simple <b>success</b> alert—check it out!</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\"danger\" class=\"bg-white\">\n  <div class=\"iq-alert-icon\">\n    <i class=\"ri-information-line\"></i>\n  </div>\n  <div class=\"iq-alert-text\">A simple <b>danger</b> alert—check it out!</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\"warning\" class=\"bg-white\">\n  <div class=\"iq-alert-icon\">\n    <i class=\"ri-alert-line\"></i>\n  </div>\n  <div class=\"iq-alert-text\">A simple <b>warning</b> alert—check it out!</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\"info\" class=\"bg-white\">\n  <div class=\"iq-alert-icon\">\n    <i class=\"ri-information-line\"></i>\n  </div>\n  <div class=\"iq-alert-text\">A simple <b>info</b> alert—check it out!</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\"light\" class=\"bg-white\">\n  <div class=\"iq-alert-icon\">\n    <i class=\"ri-alert-line\"></i>\n  </div>\n  <div class=\"iq-alert-text\">A simple <b>light</b> alert—check it out!</div>\n</b-alert>\n")])])])])]), _c('b-alert', {
          staticClass: "bg-white",
          attrs: {
            "show": true,
            "variant": "primary"
          }
        }, [_c('div', {
          staticClass: "iq-alert-icon"
        }, [_c('i', {
          staticClass: "ri-alert-line"
        })]), _c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("primary")]), _vm._v(" alert—check it out!")])]), _c('b-alert', {
          staticClass: "bg-white",
          attrs: {
            "show": true,
            "variant": "secondary"
          }
        }, [_c('div', {
          staticClass: "iq-alert-icon"
        }, [_c('i', {
          staticClass: "ri-information-line"
        })]), _c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("secondary")]), _vm._v(" alert—check it out!")])]), _c('b-alert', {
          staticClass: "bg-white",
          attrs: {
            "show": true,
            "variant": "success"
          }
        }, [_c('div', {
          staticClass: "iq-alert-icon"
        }, [_c('i', {
          staticClass: "ri-alert-line"
        })]), _c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("success")]), _vm._v(" alert—check it out!")])]), _c('b-alert', {
          staticClass: "bg-white",
          attrs: {
            "show": true,
            "variant": "danger"
          }
        }, [_c('div', {
          staticClass: "iq-alert-icon"
        }, [_c('i', {
          staticClass: "ri-information-line"
        })]), _c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("danger")]), _vm._v(" alert—check it out!")])]), _c('b-alert', {
          staticClass: "bg-white",
          attrs: {
            "show": true,
            "variant": "warning"
          }
        }, [_c('div', {
          staticClass: "iq-alert-icon"
        }, [_c('i', {
          staticClass: "ri-alert-line"
        })]), _c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("warning")]), _vm._v(" alert—check it out!")])]), _c('b-alert', {
          staticClass: "bg-white",
          attrs: {
            "show": true,
            "variant": "info"
          }
        }, [_c('div', {
          staticClass: "iq-alert-icon"
        }, [_c('i', {
          staticClass: "ri-information-line"
        })]), _c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("info")]), _vm._v(" alert—check it out!")])]), _c('b-alert', {
          staticClass: "bg-white",
          attrs: {
            "show": true,
            "variant": "light"
          }
        }, [_c('div', {
          staticClass: "iq-alert-icon"
        }, [_c('i', {
          staticClass: "ri-alert-line"
        })]), _c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("light")]), _vm._v(" alert—check it out!")])])];
      },
      proxy: true
    }])
  })], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Alerts With Background")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('a', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-5",
            modifiers: {
              "collapse-5": true
            }
          }],
          staticClass: "text-primary float-right",
          attrs: {
            "role": "button"
          }
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', {
          staticClass: "mb-4"
        }, [_vm._v("Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever")]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-5"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "alert-with-background"
          }
        }, [_c('code', [_vm._v("\n<b-alert :show=\"true\" variant=\" \" class=\"text-white bg-primary\">\n  <div class=\"iq-alert-text\">A simple <b>primary</b> alert—check it out!</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\" \" class=\"text-white bg-secondary\">\n  <div class=\"iq-alert-text\">A simple <b>secondary</b> alert—check it out!</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\" \" class=\"text-white bg-success\">\n  <div class=\"iq-alert-text\">A simple <b>success</b> alert—check it out!</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\" \" class=\"text-white bg-danger\">\n  <div class=\"iq-alert-text\">A simple <b>danger</b> alert—check it out!</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\" \" class=\"text-white bg-warning\">\n  <div class=\"iq-alert-text\">A simple <b>warning</b> alert—check it out!</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\" \"  class=\"text-white bg-info\">\n  <div class=\"iq-alert-text\">A simple <b>info</b> alert—check it out!</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\" \" class=\"bg-light\">\n  <div class=\"iq-alert-text\">A simple <b>light</b> alert—check it out!</div>\n</b-alert>\n")])])])])]), _c('b-alert', {
          staticClass: "text-white bg-primary",
          attrs: {
            "show": true,
            "variant": " "
          }
        }, [_c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("primary")]), _vm._v(" alert—check it out!")])]), _c('b-alert', {
          staticClass: "text-white bg-secondary",
          attrs: {
            "show": true,
            "variant": " "
          }
        }, [_c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("secondary")]), _vm._v(" alert—check it out!")])]), _c('b-alert', {
          staticClass: "text-white bg-success",
          attrs: {
            "show": true,
            "variant": " "
          }
        }, [_c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("success")]), _vm._v(" alert—check it out!")])]), _c('b-alert', {
          staticClass: "text-white bg-danger",
          attrs: {
            "show": true,
            "variant": " "
          }
        }, [_c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("danger")]), _vm._v(" alert—check it out!")])]), _c('b-alert', {
          staticClass: "text-white bg-warning",
          attrs: {
            "show": true,
            "variant": " "
          }
        }, [_c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("warning")]), _vm._v(" alert—check it out!")])]), _c('b-alert', {
          staticClass: "text-white bg-info",
          attrs: {
            "show": true,
            "variant": " "
          }
        }, [_c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("info")]), _vm._v(" alert—check it out!")])]), _c('b-alert', {
          staticClass: "bg-light",
          attrs: {
            "show": true,
            "variant": " "
          }
        }, [_c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("light")]), _vm._v(" alert—check it out!")])])];
      },
      proxy: true
    }])
  })], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Background Alerts With Icons")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('a', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-6",
            modifiers: {
              "collapse-6": true
            }
          }],
          staticClass: "text-primary float-right",
          attrs: {
            "role": "button"
          }
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', {
          staticClass: "mb-4"
        }, [_vm._v("Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever")]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-6"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "alert-with-background-icon"
          }
        }, [_c('code', [_vm._v("\n<b-alert :show=\"true\" variant=\" \" class=\"text-white bg-primary\">\n  <div class=\"iq-alert-icon\">\n    <i class=\"ri-alert-line\"></i>\n  </div>\n  <div class=\"iq-alert-text\">A simple <b>primary</b> alert—check it out!</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\" \" class=\"text-white bg-secondary\">\n  <div class=\"iq-alert-icon\">\n    <i class=\"ri-information-line\"></i>\n  </div>\n  <div class=\"iq-alert-text\">A simple <b>secondary</b> alert—check it out!</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\" \" class=\"text-white bg-success\">\n  <div class=\"iq-alert-icon\">\n    <i class=\"ri-alert-line\"></i>\n  </div>\n  <div class=\"iq-alert-text\">A simple <b>success</b> alert—check it out!</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\" \" class=\"text-white bg-danger\">\n  <div class=\"iq-alert-icon\">\n    <i class=\"ri-information-line\"></i>\n  </div>\n  <div class=\"iq-alert-text\">A simple <b>danger</b> alert—check it out!</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\" \" class=\"text-white bg-warning\">\n  <div class=\"iq-alert-icon\">\n    <i class=\"ri-alert-line\"></i>\n  </div>\n  <div class=\"iq-alert-text\">A simple <b>warning</b> alert—check it out!</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\" \" class=\"text-white bg-info\">\n  <div class=\"iq-alert-icon\">\n    <i class=\"ri-information-line\"></i>\n  </div>\n  <div class=\"iq-alert-text\">A simple <b>info</b> alert—check it out!</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\" \" class=\"bg-light\">\n  <div class=\"iq-alert-icon\">\n    <i class=\"ri-alert-line\"></i>\n  </div>\n  <div class=\"iq-alert-text\">A simple <b>light</b> alert—check it out!</div>\n</b-alert>\n")])])])])]), _c('b-alert', {
          staticClass: "text-white bg-primary",
          attrs: {
            "show": true,
            "variant": " "
          }
        }, [_c('div', {
          staticClass: "iq-alert-icon"
        }, [_c('i', {
          staticClass: "ri-alert-line"
        })]), _c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("primary")]), _vm._v(" alert—check it out!")])]), _c('b-alert', {
          staticClass: "text-white bg-secondary",
          attrs: {
            "show": true,
            "variant": " "
          }
        }, [_c('div', {
          staticClass: "iq-alert-icon"
        }, [_c('i', {
          staticClass: "ri-information-line"
        })]), _c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("secondary")]), _vm._v(" alert—check it out!")])]), _c('b-alert', {
          staticClass: "text-white bg-success",
          attrs: {
            "show": true,
            "variant": " "
          }
        }, [_c('div', {
          staticClass: "iq-alert-icon"
        }, [_c('i', {
          staticClass: "ri-alert-line"
        })]), _c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("success")]), _vm._v(" alert—check it out!")])]), _c('b-alert', {
          staticClass: "text-white bg-danger",
          attrs: {
            "show": true,
            "variant": " "
          }
        }, [_c('div', {
          staticClass: "iq-alert-icon"
        }, [_c('i', {
          staticClass: "ri-information-line"
        })]), _c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("danger")]), _vm._v(" alert—check it out!")])]), _c('b-alert', {
          staticClass: "text-white bg-warning",
          attrs: {
            "show": true,
            "variant": " "
          }
        }, [_c('div', {
          staticClass: "iq-alert-icon"
        }, [_c('i', {
          staticClass: "ri-alert-line"
        })]), _c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("warning")]), _vm._v(" alert—check it out!")])]), _c('b-alert', {
          staticClass: "text-white bg-info",
          attrs: {
            "show": true,
            "variant": " "
          }
        }, [_c('div', {
          staticClass: "iq-alert-icon"
        }, [_c('i', {
          staticClass: "ri-information-line"
        })]), _c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("info")]), _vm._v(" alert—check it out!")])]), _c('b-alert', {
          staticClass: "bg-light",
          attrs: {
            "show": true,
            "variant": " "
          }
        }, [_c('div', {
          staticClass: "iq-alert-icon"
        }, [_c('i', {
          staticClass: "ri-alert-line"
        })]), _c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("light")]), _vm._v(" alert—check it out!")])])];
      },
      proxy: true
    }])
  })], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Alerts Dismissing")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('a', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-7",
            modifiers: {
              "collapse-7": true
            }
          }],
          staticClass: "text-primary float-right",
          attrs: {
            "role": "button"
          }
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', {
          staticClass: "mb-4"
        }, [_vm._v("Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever")]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-7"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "alert-with-dismiss"
          }
        }, [_c('code', [_vm._v("\n<b-alert :show=\"true\" variant=\" \" dismissible fade class=\"text-white bg-primary\">\n  <div class=\"iq-alert-text\">A simple <b>primary</b> alert—check it out!</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\" \" dismissible fade class=\"text-white bg-secondary\">\n  <div class=\"iq-alert-text\">A simple <b>secondary</b> alert—check it out!</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\" \" dismissible fade class=\"text-white bg-success\">\n  <div class=\"iq-alert-text\">A simple <b>success</b> alert—check it out!</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\" \" dismissible fade class=\"text-white bg-danger\">\n  <div class=\"iq-alert-text\">A simple <b>danger</b> alert—check it out!</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\" \" dismissible fade class=\"text-white bg-warning\">\n  <div class=\"iq-alert-text\">A simple <b>warning</b> alert—check it out!</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\" \" dismissible fade  class=\"text-white bg-info\">\n  <div class=\"iq-alert-text\">A simple <b>info</b> alert—check it out!</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\" \" dismissible fade class=\"bg-light\">\n  <div class=\"iq-alert-text\">A simple <b>light</b> alert—check it out!</div>\n</b-alert>\n")])])])])]), _c('b-alert', {
          staticClass: "text-white bg-primary",
          attrs: {
            "show": true,
            "variant": " ",
            "dismissible": "",
            "fade": ""
          }
        }, [_c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("primary")]), _vm._v(" alert—check it out!")])]), _c('b-alert', {
          staticClass: "text-white bg-secondary",
          attrs: {
            "show": true,
            "variant": " ",
            "dismissible": "",
            "fade": ""
          }
        }, [_c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("secondary")]), _vm._v(" alert—check it out!")])]), _c('b-alert', {
          staticClass: "text-white bg-success",
          attrs: {
            "show": true,
            "variant": " ",
            "dismissible": "",
            "fade": ""
          }
        }, [_c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("success")]), _vm._v(" alert—check it out!")])]), _c('b-alert', {
          staticClass: "text-white bg-danger",
          attrs: {
            "show": true,
            "variant": " ",
            "dismissible": "",
            "fade": ""
          }
        }, [_c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("danger")]), _vm._v(" alert—check it out!")])]), _c('b-alert', {
          staticClass: "text-white bg-warning",
          attrs: {
            "show": true,
            "variant": " ",
            "dismissible": "",
            "fade": ""
          }
        }, [_c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("warning")]), _vm._v(" alert—check it out!")])]), _c('b-alert', {
          staticClass: "text-white bg-info",
          attrs: {
            "show": true,
            "variant": " ",
            "dismissible": "",
            "fade": ""
          }
        }, [_c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("info")]), _vm._v(" alert—check it out!")])]), _c('b-alert', {
          staticClass: "bg-light",
          attrs: {
            "show": true,
            "variant": " ",
            "dismissible": "",
            "fade": ""
          }
        }, [_c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("light")]), _vm._v(" alert—check it out!")])])];
      },
      proxy: true
    }])
  })], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Alerts Dismissing With Icons")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('a', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-8",
            modifiers: {
              "collapse-8": true
            }
          }],
          staticClass: "text-primary float-right",
          attrs: {
            "role": "button"
          }
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', {
          staticClass: "mb-4"
        }, [_vm._v("Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever")]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-8"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "alert-with-dismiss-icon"
          }
        }, [_c('code', [_vm._v("\n<b-alert :show=\"true\" variant=\" \" dismissible fade class=\"text-white bg-primary\">\n  <div class=\"iq-alert-icon\">\n    <i class=\"ri-alert-line\"></i>\n  </div>\n  <div class=\"iq-alert-text\">A simple <b>primary</b> alert—check it out!</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\" \" dismissible fade class=\"text-white bg-secondary\">\n  <div class=\"iq-alert-icon\">\n    <i class=\"ri-information-line\"></i>\n  </div>\n  <div class=\"iq-alert-text\">A simple <b>secondary</b> alert—check it out!</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\" \" dismissible fade class=\"text-white bg-success\">\n  <div class=\"iq-alert-icon\">\n    <i class=\"ri-alert-line\"></i>\n  </div>\n  <div class=\"iq-alert-text\">A simple <b>success</b> alert—check it out!</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\" \" dismissible fade class=\"text-white bg-danger\">\n  <div class=\"iq-alert-icon\">\n    <i class=\"ri-information-line\"></i>\n  </div>\n  <div class=\"iq-alert-text\">A simple <b>danger</b> alert—check it out!</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\" \" dismissible fade class=\"text-white bg-warning\">\n  <div class=\"iq-alert-icon\">\n    <i class=\"ri-alert-line\"></i>\n  </div>\n  <div class=\"iq-alert-text\">A simple <b>warning</b> alert—check it out!</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\" \" dismissible fade class=\"text-white bg-info\">\n  <div class=\"iq-alert-icon\">\n    <i class=\"ri-information-line\"></i>\n  </div>\n  <div class=\"iq-alert-text\">A simple <b>info</b> alert—check it out!</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\" \" dismissible fade class=\"bg-light\">\n  <div class=\"iq-alert-icon\">\n    <i class=\"ri-alert-line\"></i>\n  </div>\n  <div class=\"iq-alert-text\">A simple <b>light</b> alert—check it out!</div>\n</b-alert>\n")])])])])]), _c('b-alert', {
          staticClass: "text-white bg-primary",
          attrs: {
            "show": true,
            "variant": " ",
            "dismissible": "",
            "fade": ""
          }
        }, [_c('div', {
          staticClass: "iq-alert-icon"
        }, [_c('i', {
          staticClass: "ri-alert-line"
        })]), _c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("primary")]), _vm._v(" alert—check it out!")])]), _c('b-alert', {
          staticClass: "text-white bg-secondary",
          attrs: {
            "show": true,
            "variant": " ",
            "dismissible": "",
            "fade": ""
          }
        }, [_c('div', {
          staticClass: "iq-alert-icon"
        }, [_c('i', {
          staticClass: "ri-information-line"
        })]), _c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("secondary")]), _vm._v(" alert—check it out!")])]), _c('b-alert', {
          staticClass: "text-white bg-success",
          attrs: {
            "show": true,
            "variant": " ",
            "dismissible": "",
            "fade": ""
          }
        }, [_c('div', {
          staticClass: "iq-alert-icon"
        }, [_c('i', {
          staticClass: "ri-alert-line"
        })]), _c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("success")]), _vm._v(" alert—check it out!")])]), _c('b-alert', {
          staticClass: "text-white bg-danger",
          attrs: {
            "show": true,
            "variant": " ",
            "dismissible": "",
            "fade": ""
          }
        }, [_c('div', {
          staticClass: "iq-alert-icon"
        }, [_c('i', {
          staticClass: "ri-information-line"
        })]), _c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("danger")]), _vm._v(" alert—check it out!")])]), _c('b-alert', {
          staticClass: "text-white bg-warning",
          attrs: {
            "show": true,
            "variant": " ",
            "dismissible": "",
            "fade": ""
          }
        }, [_c('div', {
          staticClass: "iq-alert-icon"
        }, [_c('i', {
          staticClass: "ri-alert-line"
        })]), _c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("warning")]), _vm._v(" alert—check it out!")])]), _c('b-alert', {
          staticClass: "text-white bg-info",
          attrs: {
            "show": true,
            "variant": " ",
            "dismissible": "",
            "fade": ""
          }
        }, [_c('div', {
          staticClass: "iq-alert-icon"
        }, [_c('i', {
          staticClass: "ri-information-line"
        })]), _c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("info")]), _vm._v(" alert—check it out!")])]), _c('b-alert', {
          staticClass: "bg-light",
          attrs: {
            "show": true,
            "variant": " ",
            "dismissible": "",
            "fade": ""
          }
        }, [_c('div', {
          staticClass: "iq-alert-icon"
        }, [_c('i', {
          staticClass: "ri-alert-line"
        })]), _c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple "), _c('b', [_vm._v("light")]), _vm._v(" alert—check it out!")])])];
      },
      proxy: true
    }])
  })], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Alerts With Background")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('a', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-9",
            modifiers: {
              "collapse-9": true
            }
          }],
          staticClass: "text-primary float-right",
          attrs: {
            "role": "button"
          }
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', {
          staticClass: "mb-4"
        }, [_vm._v("Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever")]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-9"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "alert-with-link"
          }
        }, [_c('code', [_vm._v("\n<b-alert :show=\"true\" variant=\"primary\">\n  <div class=\"iq-alert-text\">A simple light alert with <a href=\"#\" class=\"alert-link\">an example link</a>. Give it a click if you like.</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\"secondary\">\n  <div class=\"iq-alert-text\">A simple light alert with <a href=\"#\" class=\"alert-link\">an example link</a>. Give it a click if you like.</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\"success\">\n  <div class=\"iq-alert-text\">A simple light alert with <a href=\"#\" class=\"alert-link\">an example link</a>. Give it a click if you like.</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\"danger\">\n  <div class=\"iq-alert-text\">A simple light alert with <a href=\"#\" class=\"alert-link\">an example link</a>. Give it a click if you like.</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\"warning\">\n  <div class=\"iq-alert-text\">A simple light alert with <a href=\"#\" class=\"alert-link\">an example link</a>. Give it a click if you like.</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\"info\">\n  <div class=\"iq-alert-text\">A simple light alert with <a href=\"#\" class=\"alert-link\">an example link</a>. Give it a click if you like.</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\"light\">\n  <div class=\"iq-alert-text\">A simple light alert with <a href=\"#\" class=\"alert-link\">an example link</a>. Give it a click if you like.</div>\n</b-alert>\n")])])])])]), _c('b-alert', {
          attrs: {
            "show": true,
            "variant": "primary"
          }
        }, [_c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple light alert with "), _c('a', {
          staticClass: "alert-link",
          attrs: {
            "href": "#"
          }
        }, [_vm._v("an example link")]), _vm._v(". Give it a click if you like.")])]), _c('b-alert', {
          attrs: {
            "show": true,
            "variant": "secondary"
          }
        }, [_c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple light alert with "), _c('a', {
          staticClass: "alert-link",
          attrs: {
            "href": "#"
          }
        }, [_vm._v("an example link")]), _vm._v(". Give it a click if you like.")])]), _c('b-alert', {
          attrs: {
            "show": true,
            "variant": "success"
          }
        }, [_c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple light alert with "), _c('a', {
          staticClass: "alert-link",
          attrs: {
            "href": "#"
          }
        }, [_vm._v("an example link")]), _vm._v(". Give it a click if you like.")])]), _c('b-alert', {
          attrs: {
            "show": true,
            "variant": "danger"
          }
        }, [_c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple light alert with "), _c('a', {
          staticClass: "alert-link",
          attrs: {
            "href": "#"
          }
        }, [_vm._v("an example link")]), _vm._v(". Give it a click if you like.")])]), _c('b-alert', {
          attrs: {
            "show": true,
            "variant": "warning"
          }
        }, [_c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple light alert with "), _c('a', {
          staticClass: "alert-link",
          attrs: {
            "href": "#"
          }
        }, [_vm._v("an example link")]), _vm._v(". Give it a click if you like.")])]), _c('b-alert', {
          attrs: {
            "show": true,
            "variant": "info"
          }
        }, [_c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple light alert with "), _c('a', {
          staticClass: "alert-link",
          attrs: {
            "href": "#"
          }
        }, [_vm._v("an example link")]), _vm._v(". Give it a click if you like.")])]), _c('b-alert', {
          attrs: {
            "show": true,
            "variant": "light"
          }
        }, [_c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple light alert with "), _c('a', {
          staticClass: "alert-link",
          attrs: {
            "href": "#"
          }
        }, [_vm._v("an example link")]), _vm._v(". Give it a click if you like.")])])];
      },
      proxy: true
    }])
  })], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Background Alerts With Icons")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('a', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-10",
            modifiers: {
              "collapse-10": true
            }
          }],
          staticClass: "text-primary float-right",
          attrs: {
            "role": "button"
          }
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', {
          staticClass: "mb-4"
        }, [_vm._v("Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever")]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-10"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "alert-with-link-icon"
          }
        }, [_c('code', [_vm._v("\n<b-alert :show=\"true\" variant=\"primary\" class=\"text-white bg-primary\">\n  <div class=\"iq-alert-icon\">\n    <i class=\"ri-alert-line\"></i>\n  </div>\n  <div class=\"iq-alert-text\">A simple light alert with <a href=\"#\" class=\"alert-link text-white \">an example link</a>. Give it a click if you like.</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\"secondary\" class=\"text-white bg-secondary\">\n  <div class=\"iq-alert-icon\">\n    <i class=\"ri-information-line\"></i>\n  </div>\n  <div class=\"iq-alert-text\">A simple light alert with <a href=\"#\" class=\"alert-link text-white\">an example link</a>. Give it a click if you like.</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\"success\" class=\"text-white bg-success\">\n  <div class=\"iq-alert-icon\">\n    <i class=\"ri-alert-line\"></i>\n  </div>\n  <div class=\"iq-alert-text\">A simple light alert with <a href=\"#\" class=\"alert-link text-white\">an example link</a>. Give it a click if you like.</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\"danger\" class=\"text-white bg-danger\">\n  <div class=\"iq-alert-icon\">\n    <i class=\"ri-information-line\"></i>\n  </div>\n  <div class=\"iq-alert-text\">A simple light alert with <a href=\"#\" class=\"alert-link text-white\">an example link</a>. Give it a click if you like.</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\"warning\" class=\"text-white bg-warning\">\n  <div class=\"iq-alert-icon\">\n    <i class=\"ri-alert-line\"></i>\n  </div>\n  <div class=\"iq-alert-text\">A simple light alert with <a href=\"#\" class=\"alert-link text-white\">an example link</a>. Give it a click if you like.</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\"info\" class=\"text-white bg-info\">\n  <div class=\"iq-alert-icon\">\n    <i class=\"ri-information-line\"></i>\n  </div>\n  <div class=\"iq-alert-text\">A simple light alert with <a href=\"#\" class=\"alert-link text-white\">an example link</a>. Give it a click if you like.</div>\n</b-alert>\n<b-alert :show=\"true\" variant=\"light\" class=\"bg-light\">\n  <div class=\"iq-alert-icon\">\n    <i class=\"ri-alert-line\"></i>\n  </div>\n  <div class=\"iq-alert-text\">A simple light alert with <a href=\"#\" class=\"alert-link text-white\">an example link</a>. Give it a click if you like.</div>\n</b-alert>\n")])])])])]), _c('b-alert', {
          staticClass: "text-white bg-primary",
          attrs: {
            "show": true,
            "variant": "primary"
          }
        }, [_c('div', {
          staticClass: "iq-alert-icon"
        }, [_c('i', {
          staticClass: "ri-alert-line"
        })]), _c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple light alert with "), _c('a', {
          staticClass: "alert-link text-white",
          attrs: {
            "href": "#"
          }
        }, [_vm._v("an example link")]), _vm._v(". Give it a click if you like.")])]), _c('b-alert', {
          staticClass: "text-white bg-secondary",
          attrs: {
            "show": true,
            "variant": "secondary"
          }
        }, [_c('div', {
          staticClass: "iq-alert-icon"
        }, [_c('i', {
          staticClass: "ri-information-line"
        })]), _c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple light alert with "), _c('a', {
          staticClass: "alert-link text-white",
          attrs: {
            "href": "#"
          }
        }, [_vm._v("an example link")]), _vm._v(". Give it a click if you like.")])]), _c('b-alert', {
          staticClass: "text-white bg-success",
          attrs: {
            "show": true,
            "variant": "success"
          }
        }, [_c('div', {
          staticClass: "iq-alert-icon"
        }, [_c('i', {
          staticClass: "ri-alert-line"
        })]), _c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple light alert with "), _c('a', {
          staticClass: "alert-link text-white",
          attrs: {
            "href": "#"
          }
        }, [_vm._v("an example link")]), _vm._v(". Give it a click if you like.")])]), _c('b-alert', {
          staticClass: "text-white bg-danger",
          attrs: {
            "show": true,
            "variant": "danger"
          }
        }, [_c('div', {
          staticClass: "iq-alert-icon"
        }, [_c('i', {
          staticClass: "ri-information-line"
        })]), _c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple light alert with "), _c('a', {
          staticClass: "alert-link text-white",
          attrs: {
            "href": "#"
          }
        }, [_vm._v("an example link")]), _vm._v(". Give it a click if you like.")])]), _c('b-alert', {
          staticClass: "text-white bg-warning",
          attrs: {
            "show": true,
            "variant": "warning"
          }
        }, [_c('div', {
          staticClass: "iq-alert-icon"
        }, [_c('i', {
          staticClass: "ri-alert-line"
        })]), _c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple light alert with "), _c('a', {
          staticClass: "alert-link text-white",
          attrs: {
            "href": "#"
          }
        }, [_vm._v("an example link")]), _vm._v(". Give it a click if you like.")])]), _c('b-alert', {
          staticClass: "text-white bg-info",
          attrs: {
            "show": true,
            "variant": "info"
          }
        }, [_c('div', {
          staticClass: "iq-alert-icon"
        }, [_c('i', {
          staticClass: "ri-information-line"
        })]), _c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple light alert with "), _c('a', {
          staticClass: "alert-link text-white",
          attrs: {
            "href": "#"
          }
        }, [_vm._v("an example link")]), _vm._v(". Give it a click if you like.")])]), _c('b-alert', {
          staticClass: "bg-light",
          attrs: {
            "show": true,
            "variant": "light"
          }
        }, [_c('div', {
          staticClass: "iq-alert-icon"
        }, [_c('i', {
          staticClass: "ri-alert-line"
        })]), _c('div', {
          staticClass: "iq-alert-text"
        }, [_vm._v("A simple light alert with "), _c('a', {
          staticClass: "alert-link text-white",
          attrs: {
            "href": "#"
          }
        }, [_vm._v("an example link")]), _vm._v(". Give it a click if you like.")])])];
      },
      proxy: true
    }])
  })], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Additional content")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('a', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-11",
            modifiers: {
              "collapse-11": true
            }
          }],
          staticClass: "text-primary float-right",
          attrs: {
            "role": "button"
          }
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', {
          staticClass: "mb-4"
        }, [_vm._v("Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever")]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-11"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "alert-with-link-additional"
          }
        }, [_c('code', [_vm._v("\n<div class=\"col-sm-6\">\n  <b-alert :show=\"true\" variant=\"primary\">\n    <div class=\"iq-alert-text\">\n      <h5 class=\"alert-heading\">Well done!</h5>\n      <p>Aww yeah, you successfully read this important alert message. This example text is going to run a bit longer so that you can see how spacing within an alert works with this kind of content.</p>\n      <hr>\n      <p class=\"mb-0\">Whenever you need to, be sure to use margin utilities to keep things nice and tidy.</p>\n    </div>\n  </b-alert>\n</div>\n<div class=\"col-sm-6\">\n  <b-alert :show=\"true\" variant=\"success\">\n    <div class=\"iq-alert-text\">\n      <h5 class=\"alert-heading\">Well done!</h5>\n      <p>Aww yeah, you successfully read this important alert message. This example text is going to run a bit longer so that you can see how spacing within an alert works with this kind of content.</p>\n      <hr>\n      <p class=\"mb-0\">Whenever you need to, be sure to use margin utilities to keep things nice and tidy.</p>\n    </div>\n  </b-alert>\n</div>\n")])])])])]), _c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-sm-6"
        }, [_c('b-alert', {
          attrs: {
            "show": true,
            "variant": "primary"
          }
        }, [_c('div', {
          staticClass: "iq-alert-text"
        }, [_c('h5', {
          staticClass: "alert-heading"
        }, [_vm._v("Well done!")]), _c('p', [_vm._v("Aww yeah, you successfully read this important alert message. This example text is going to run a bit longer so that you can see how spacing within an alert works with this kind of content.")]), _c('hr'), _c('p', {
          staticClass: "mb-0"
        }, [_vm._v("Whenever you need to, be sure to use margin utilities to keep things nice and tidy.")])])])], 1), _c('div', {
          staticClass: "col-sm-6"
        }, [_c('b-alert', {
          attrs: {
            "show": true,
            "variant": "success"
          }
        }, [_c('div', {
          staticClass: "iq-alert-text"
        }, [_c('h5', {
          staticClass: "alert-heading"
        }, [_vm._v("Well done!")]), _c('p', [_vm._v("Aww yeah, you successfully read this important alert message. This example text is going to run a bit longer so that you can see how spacing within an alert works with this kind of content.")]), _c('hr'), _c('p', {
          staticClass: "mb-0"
        }, [_vm._v("Whenever you need to, be sure to use margin utilities to keep things nice and tidy.")])])])], 1)])];
      },
      proxy: true
    }])
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }